export const reDistrictConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_DISTRICT_SUCCESS',
		REQUEST : 'GET_PAGED_DISTRICT_REQUEST',
		FAILURE : 'GET_PAGED_DISTRICT_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_DISTRICT_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_DISTRICT_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_DISTRICT_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_DISTRICT_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_DISTRICT_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_DISTRICT_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_DISTRICT_REQUEST',
		SUCCESS : 'GET_LIST_DISTRICT_SUCCESS',
		FAILURE : 'GET_LIST_DISTRICT_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_DISTRICT_REQUEST',
		SUCCESS : 'CREATE_DISTRICT_SUCCESS',
		FAILURE : 'CREATE_DISTRICT_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_DISTRICT_REQUEST',
		SUCCESS : 'DELETE_DISTRICT_SUCCESS',
		FAILURE : 'DELETE_DISTRICT_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_DISTRICT_REQUEST',
		SUCCESS : 'UPDATE_DISTRICT_SUCCESS',
		FAILURE : 'UPDATE_DISTRICT_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_DISTRICT_REQUEST',
		SUCCESS : 'RESTORE_DISTRICT_SUCCESS',
		FAILURE : 'RESTORE_DISTRICT_FAILURE'
	},
	getListActualByRegion: {
		SUCCESS : 'GET_LIST_ACTUAL_BY_REGION_SUCCESS',
		REQUEST : 'GET_LIST_ACTUAL_BY_REGION_REQUEST',
		FAILURE : 'GET_LIST_ACTUAL_BY_REGION_FAILURE'
	},
	CLEAR: 'CLEAR_DISTRICT'
}